(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-add-to-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const siteFooter = document.querySelector('footer');
  const cartDrawerEl = document.getElementById('mini-cart');
  
  // --- PASSO 1: ACHAR O FORMULÁRIO PRINCIPAL E O BOTÃO STICKY ---
  
  // ESTA É A CORREÇÃO:
  // Procura por qualquer tag 'form' cujo ID *comece com* 'product-form-main-'
  const mainForm = document.querySelector('form[id*="product-form-main-"]');
  
  const stickyButton = stickyBar ? stickyBar.querySelector('.sticky-add-to-cart__button') : null;
  
  if (!stickyBar || !mainForm || !stickyButton) {
    if (!mainForm) {
      console.warn('Sticky Add to Cart: Não foi possível encontrar o formulário principal com o seletor: form[id*="product-form-main-"]');
    }
    return;
  }

  // --- PASSO 2: CONECTAR O BOTÃO AO FORMULÁRIO ---
  // Agora temos o ID correto, seja ele qual for.
  //
  // getAttribute('id') — NÃO usar mainForm.id.
  // O form do produto tem <input type="hidden" name="id">, e controles nomeados
  // viram propriedades do próprio <form>. Logo `mainForm.id` devolve esse INPUT,
  // não a string do id (o tema depende disso em theme.js: `this.id.disabled = false`).
  // Com `.id`, o setAttribute gravava form="[object HTMLInputElement]", o botão
  // ficava sem form owner e o clique não disparava submit nenhum.
  const mainFormId = mainForm.getAttribute('id');
  stickyButton.setAttribute('form', mainFormId);
  

  // --- PASSO 3: LÓGICA DE VISIBILIDADE ---
  let isFormVisible = true;
  let isFooterVisible = false;
  let isCartOpen = false;

  function updateStickyState() {
    isCartOpen = (cartDrawerEl && cartDrawerEl.hasAttribute('open'));
    // O guard do PASSO 1 não cobre siteFooter — sem este !! um tema sem <footer>
    // derruba a função inteira com TypeError.
    isFooterVisible = !!siteFooter && (siteFooter.getBoundingClientRect().top < window.innerHeight);

    if (isCartOpen) {
      stickyBar.classList.remove('active');
    } else if (isFooterVisible) {
      stickyBar.classList.remove('active');
      stickyBar.classList.add('hide'); 
    } else {
      stickyBar.classList.remove('hide');
      // A barra fica 'active' sempre que o formulário principal não está inteiro
      // na tela. Este toggle é o que faltava: antes o ramo só removia 'hide', e
      // 'active' nunca voltava. Resultado — depois de fechar o carrinho ou sair
      // do rodapé, a barra só reaparecia se o formulário cruzasse o threshold do
      // observer outra vez, o que podia não acontecer mais na sessão.
      stickyBar.classList.toggle('active', !isFormVisible);
    }
  }

  // --- Observador 1: Formulário do Produto (para visibilidade) ---
  const formObserver = new IntersectionObserver(
    ([e]) => {
      // intersectionRatio < 1 significa que o formulário *não* está 100% visível (começou a sair da tela)
      const formIsNotFullyVisible = (e.intersectionRatio < 1);
      
      // Só alimenta o estado; quem decide as classes é updateStickyState(),
      // ponto único de verdade para os três sinais (form, rodapé, carrinho).
      isFormVisible = !formIsNotFullyVisible;
      updateStickyState();
    },
    { threshold: [1.0], rootMargin: '0px 0px -1px 0px' }
  );
  formObserver.observe(mainForm);
  
  // --- Observador 2: Rodapé ---
  if (siteFooter) {
    const footerObserver = new IntersectionObserver(
      ([e]) => {
        isFooterVisible = (e.intersectionRatio > 0);
        updateStickyState();
      },
      { threshold: [0], rootMargin: '0px 0px -70px 0px' }
    );
    footerObserver.observe(siteFooter);
  }

  // --- Observador 3: Gaveta do Carrinho (Cart Drawer) ---
  if (cartDrawerEl) {
    const cartObserver = new MutationObserver(() => {
      updateStickyState();
    });
    cartObserver.observe(cartDrawerEl, { 
      attributes: true, 
      attributeFilter: ['open']
    });
  }

  // Timeout inicial de visibilidade
  setTimeout(() => {
    stickyBar.style.visibility = 'visible';
  }, 300);
  
  // Executa uma verificação inicial
  updateStickyState();
});

  } catch(e) { console.error(e); }
})();
})();
